import Vue from 'vue'

const preventReClick = Vue.directive('preventReClick', {
    inserted: function(el, binding) {
        el.addEventListener('click', (e) => {
            if (!el.disabled) {
               el.style.pointerEvents = 'none'
               el.style.opacity = 0.7
                setTimeout(() => {
                   el.style.pointerEvents = 'auto'
                   el.style.opacity = 1
                }, binding.value || 3000)
            } else {
            	// disabled为true时，阻止默认的@click事件
                e.preventDefault()
                e.stopPropagation()
            }
        }, true)
    }
});

const testNull=function(that,val,name){
        if(val==''||val==undefined){
          that.$message.error({
              type: 'warning',
              message: name+'不能为空',
          })
          return false
        }else{
          return true
        }
      }

const testLength=function(that,val,startLen,endLen,name){
      if(startLen==-1){
        if(val.length>endLen){
          that.$message({
             message: name+'不能超过'+endLen+'个字',
             type: 'warning'
          })
          return false
        }else{
          return true
        }
      }else{
        if(val.length>endLen||val.length<startLen){
          that.$message({
             message: name+'长度为'+startLen+'-'+endLen+'个字符',
             type: 'warning'
          })
          return false
        }else{
          return true
        }
      }

      }



export { preventReClick ,getBirthdayFromCard,testNull,testLength}



// WEBPACK FOOTER //
// ./src/api/utils.js